import clsx from "clsx";

interface AvatarProps {
  src?: string;
  name: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function Avatar({ src, name, size = "md", className }: AvatarProps) {
  const initials = name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  const sizeClass = {
    sm: "h-8 w-8 text-xs",
    md: "h-10 w-10 text-sm",
    lg: "h-14 w-14 text-base",
  }[size];

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className={clsx("rounded-full object-cover", sizeClass, className)}
      />
    );
  }

  return (
    <div
      className={clsx(
        "rounded-full bg-orange/10 text-orange font-body font-bold flex items-center justify-center",
        sizeClass,
        className,
      )}
    >
      {initials}
    </div>
  );
}
